import { isAbsoluteUrl } from 'utils/url-helpers';

export const valueListToQueryStr = (
  list: string[] | number[],
  paramName: string,
): string => (list.length > 0 ? `&${paramName}=${list.join(',')}` : '');

export const addQueryData = (
  baseUrl: string,
  data: { [string]: Object },
): string => {
  const dummyDomain = 'http://dummy.test';
  const isAbsolute = isAbsoluteUrl(baseUrl);
  const adjustedUrl = isAbsolute
    ? baseUrl
    : `${dummyDomain}${baseUrl[0] === '/' ? baseUrl : `/${baseUrl}`}`;
  const url = new URL(adjustedUrl);

  Object.entries(data).forEach(([key, value]) => {
    if (value !== null) {
      url.searchParams.set(key, String(value));
    }
  });

  return isAbsolute ? url.toString() : url.toString().replace(dummyDomain, '');
};
